import { atom } from 'jotai'
import { SIDEBAR_CONFIG } from '@/constants/sideBarConfig'

export const sidebarLocationPathAtom = atom<string>('/')
export const sidebarOpenAtom = atom<boolean>(false)
export const sidebarConfigPathAtom = atom(SIDEBAR_CONFIG)
